"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.preventWhitespaceCollapse = void 0;
var AppfolioHTML_1 = __importDefault(require("./AppfolioHTML"));
var isFixedWidthOptions = function (u) {
    return typeof u === 'object' &&
        u !== null &&
        typeof u['backdrop'] === 'string' &&
        typeof u['pixels'] === 'number';
};
var BACKGROUND = '#fff';
var COLOR = '#000';
var FIXED_WIDTH = {
    backdrop: '#edf0f2',
    pixels: 600
};
// @see https://github.com/xeger/quill-deltacvt/blob/main/src/generators/MinimalHTML.ts#L11
var LINE_STYLES = {
    list: 'margin:0px;list-style-position:inside;padding-left:1.5rem'
};
var buildNbspSpaceArray = function (length) {
    var result = [];
    for (var index = 0; index < length; index++) {
        if (index % 2 === 0) {
            result.push('&nbsp;');
        }
        else {
            result.push(' ');
        }
    }
    return result;
};
function preventWhitespaceCollapse(string) {
    return string
        .replace(/^ +/g, function (substring) {
        return buildNbspSpaceArray(substring.length).join('');
    })
        .replace(/ +$/g, function (substring) {
        return buildNbspSpaceArray(substring.length).reverse().join('');
    })
        .replace(/  +/g, function (substring) {
        return buildNbspSpaceArray(substring.length).join('');
    });
}
exports.preventWhitespaceCollapse = preventWhitespaceCollapse;
/**
 * HTML generator that is suitable for email contents; derives from
 * a base class that knows about AppFolio's proprietary Quill formats.
 */
var AppfolioHTMLForEmail = /** @class */ (function (_super) {
    __extends(AppfolioHTMLForEmail, _super);
    function AppfolioHTMLForEmail(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        var background = options.background, color = options.color, fixedWidth = options.fixedWidth, masthead = options.masthead;
        _this.background = _this.escape(background || BACKGROUND);
        _this.color = _this.escape(color || COLOR);
        _this.masthead = masthead || '';
        if (fixedWidth === true) {
            _this.fixedWidth = FIXED_WIDTH;
        }
        else if (isFixedWidthOptions(fixedWidth)) {
            _this.fixedWidth = fixedWidth;
        }
        else if (fixedWidth) {
            throw new TypeError("Expected fixedWidth to be one of: true, false or an instance of FixedWithOptions; received a(n) ".concat(typeof fixedWidth));
        }
        return _this;
    }
    AppfolioHTMLForEmail.prototype.wrap = function (fragment) {
        var bodyStyle = "background: ".concat(this.fixedWidth ? this.fixedWidth.backdrop : this.background, "; color: ").concat(this.color, "; margin: 0; padding: ").concat(this.fixedWidth ? '32px 0px' : '0', ";");
        var wrappingStyle = this.fixedWidth
            ? "background: ".concat(this.background, "; margin: 0 auto; max-width: ").concat(this.fixedWidth.pixels, "px; padding: 32px;")
            : 'margin: 32px;';
        return [
            '<html>',
            '<head>',
            '</head>',
            "<body style=\"".concat(bodyStyle, "\"><div style=\"").concat(wrappingStyle, "\">").concat(this.masthead || '').concat(fragment, "</div></body>"),
            '</html>',
        ].join('');
    };
    // TODO: provide better interface for formatLine in @xeger/quill-deltacvt so we don't have to override the whole method here
    // @see https://github.com/xeger/quill-deltacvt/blob/master/src/generators/MinimalHTML.ts#L89
    AppfolioHTMLForEmail.prototype.formatLine = function (current, prior) {
        var align = current.align, list = current.list, text = current.text;
        var style = align ? " style=\"text-align: ".concat(align, "\"") : '';
        var html = '';
        if (list) {
            var content = text.replace(/(?:\r\n|\r|\n)/g, '');
            html = "<li".concat(style, ">").concat(preventWhitespaceCollapse(content), "</li>");
        }
        else if (text) {
            var content = text.replace(/(?:\r\n|\r|\n)/g, '');
            content = preventWhitespaceCollapse(content);
            if (content.length === 0) {
                content = '<br />';
            }
            html = "<div".concat(style, ">").concat(content, "</div>");
        }
        if (list !== (prior && prior.list)) {
            var prefix = [];
            if ((prior && prior.list) === 'bullet') {
                prefix.push("</ul>");
            }
            else if ((prior && prior.list) === 'ordered') {
                prefix.push("</ol>");
            }
            if (list === 'bullet') {
                prefix.push("<ul style=\"".concat(LINE_STYLES.list, "\">"));
            }
            else if (list === 'ordered') {
                prefix.push("<ol style=\"".concat(LINE_STYLES.list, "\">"));
            }
            html = "".concat(prefix.join('')).concat(html);
        }
        return html;
    };
    return AppfolioHTMLForEmail;
}(AppfolioHTML_1["default"]));
exports["default"] = AppfolioHTMLForEmail;
